import { createReducer, on } from '@ngrx/store';
import { IEMData, IPaymentDataResponse } from '@dch/billing-business-logic';
import {
  resetPaymentData,
  savePaymentDataFailure,
  savePaymentDataRequest,
  savePaymentDataSuccess,
} from '../actions';

export interface PaymentDataState {
  paymentData: IEMData<IPaymentDataResponse>;
}

export const initialState: PaymentDataState = {
  paymentData: { result: null, isFetching: false, hasError: false },
};

export const paymentDataReducer = createReducer(
  initialState,
  on(savePaymentDataRequest, (state) => ({
    ...state,
    paymentData: { result: null, isFetching: true, hasError: false },
  })),
  on(savePaymentDataSuccess, (state, { response }) => ({
    ...state,
    paymentData: { result: response, isFetching: false, hasError: false },
  })),
  on(savePaymentDataFailure, (state) => ({
    ...state,
    paymentData: { result: null, isFetching: false, hasError: true },
  })),
  on(resetPaymentData, (state) => ({
    ...state,
    paymentData: { result: null, isFetching: false, hasError: false },
  }))
);
